import { gql, type OperationVariables } from '@apollo/client';
import type { EMailCycle } from '@sharedInterfaces/globalEnums';
import type ICompanySettings from '@sharedInterfaces/ICompanySettings';
import Company from '@src/Objects/Company';

import GraphQL from '../graphQL';

import { companySettingsGql } from './getCompanySettings';

const query = gql`
mutation editCompanyEmailSettings($cycle: String!, $text: String!, $sendForecastMail: Boolean!, $sendUpdateReminderMail: Boolean!, $sendCertificateReminder: Boolean!) {
    editCompanyEmailSettings(cycle: $cycle, text:$text, sendForecastMail: $sendForecastMail, sendUpdateReminderMail:$sendUpdateReminderMail, sendCertificateReminder: $sendCertificateReminder) 
    ${companySettingsGql}
},
`;

export default async function editCompanyEmailSettings(
    cycle: EMailCycle,
    text: string,
    sendForecastMail: boolean,
    sendUpdateReminderMail: boolean,
    sendCertificateReminder: boolean,
) {
    const variables: OperationVariables = {
        cycle,
        text,
        sendForecastMail,
        sendUpdateReminderMail,
        sendCertificateReminder: sendCertificateReminder ? sendCertificateReminder : false,
    };
    return GraphQL.mutate<ICompanySettings>(query, variables).then((c) => new Company(c));
}
